<template>
  <div>
    <div v-if="allowTransaction">
      <div v-if="platforms.length > 0" class="p-2   mt-2">
        <div class="flex space-x-2 mb-2 flex-1 items-center">
          <span
            class="global-button cursor-pointer"
            @click="formTypeSet('YATIRIM', 2)"
          >
            Para Yatırım Talimatı
          </span>
          <span
            class="global-button cursor-pointer"
            @click="formTypeSet('ÇEKİM', 5)"
          >
            Para Çekim Talimatı
          </span>
        </div>

        <div class="border p-4 rounded-lg" v-if="form.type">
          <h4 class="text-sm font-medium">PARA {{ form.type }} TALİMATI</h4>

          <div class="flex space-x-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-20 h-20 text-tile"
              viewBox="0 0 24 24"
            >
              <defs>
                <path
                  id="solarWalletMoneyOutline0"
                  fill="currentColor"
                  d="M19 14a1 1 0 1 1-2 0a1 1 0 0 1 2 0"
                />
              </defs>
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M20.924 11.75H18.23c-1.424 0-2.481 1.059-2.481 2.25s1.057 2.25 2.48 2.25h2.718c.206-.013.295-.152.302-.236v-4.028c-.007-.084-.096-.223-.302-.235zm-.074-1.5c.066 0 .13 0 .19.004c.87.053 1.641.71 1.706 1.628c.004.06.004.125.004.185v3.866c0 .06 0 .125-.004.185c-.065.918-.836 1.575-1.707 1.629c-.059.003-.123.003-.19.003h-2.618c-2.145 0-3.981-1.628-3.981-3.75s1.836-3.75 3.98-3.75h2.603z"
                clip-rule="evenodd"
              />
              <use href="#solarWalletMoneyOutline0" />
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M20.85 10.25a1.888 1.888 0 0 1 .835.16c-.107-1.606-.402-2.844-1.326-3.769c-.749-.748-1.698-1.08-2.87-1.238l-.042-.005a.778.778 0 0 0-.032-.023l-3.736-2.477a3.987 3.987 0 0 0-4.358 0L5.586 5.375a.773.773 0 0 0-.033.023l-.042.005c-1.172.158-2.121.49-2.87 1.238c-.748.749-1.08 1.698-1.238 2.87c-.153 1.14-.153 2.595-.153 4.433v.112c0 1.838 0 3.294.153 4.433c.158 1.172.49 2.121 1.238 2.87c.749.748 1.698 1.08 2.87 1.238c1.14.153 2.595.153 4.433.153h3.112c1.838 0 3.294 0 4.433-.153c1.172-.158 2.121-.49 2.87-1.238c.924-.925 1.219-2.163 1.326-3.77c-.202.09-.42.144-.646.158c-.059.003-.123.003-.19.003h-.681c-.114 1.342-.371 2.05-.87 2.548c-.423.423-1.003.677-2.009.812c-1.027.138-2.382.14-4.289.14h-3c-1.907 0-3.261-.002-4.29-.14c-1.005-.135-1.585-.389-2.008-.812c-.423-.423-.677-1.003-.812-2.009c-.138-1.027-.14-2.382-.14-4.289c0-1.907.002-3.261.14-4.29c.135-1.005.389-1.585.812-2.008c.423-.423 1.003-.677 2.009-.812c1.028-.138 2.382-.14 4.289-.14h3c1.907 0 3.262.002 4.29.14c1.005.135 1.585.389 2.008.812c.499.498.756 1.207.87 2.548h.665zm-10.906-5h3.112c.517 0 1.003 0 1.46.003L12.85 4.148c-.8-.53-1.9-.53-2.7 0L8.483 5.253c.458-.003.944-.003 1.46-.003"
                clip-rule="evenodd"
              />
              <path
                fill="currentColor"
                d="M6 9.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5z"
              />
              <use
                href="#solarWalletMoneyOutline0"
                fill-rule="evenodd"
                clip-rule="evenodd"
              />
            </svg>

            <form
              method="post"
              action="javascript:void(0)"
              @submit.prevent="saveForm()"
            >
              <div class="flex flex-col space-y-2 items-start">
                <div class="flex space-x-2">
                  <div>
                    <label>Ödeme Kanalı</label>
                    <select
                      v-model="form.gateway_id"
                      required
                      class="uk-select"
                    >
                      <option
                        v-for="template in $root.cache.getOptions[199]"
                        :value="template.value"
                        :key="template.value"
                        >{{ template.label }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label>Tutar</label>
                    <div class="flex space-x-2">
                      <input
                        required
                        type="number"
                        class="uk-input"
                        v-model="form.amount"
                      />

                      <select v-model="form.currency_id" class="uk-select">
                        <option
                          v-for="template in $root.cache.getOptions[148]"
                          :value="template.value"
                          :key="template.value"
                          >{{ template.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <label>Platform</label>
                    <select v-model="form.login" required class="  uk-select">
                      <option
                        v-for="plt in platforms"
                        v-if="plt.type == 'REAL'"
                        :key="plt.login"
                        :value="plt.login"
                      >
                        {{ plt.login }} -
                        {{ $root.getVal(154, plt.whitelabel_id) }}
                      </option>
                    </select>
                  </div>
                </div>
                <template v-if="form.type == 'ÇEKİM'">
                  <template v-if="form.gateway_id == 1">
                    <div>
                      <label
                        >IBAN No
                        <span class="text-xs"
                          >ör: TR444433332222111111111111</span
                        ></label
                      >
                      <input
                        type="text"
                        class="uk-input w-full"
                        v-model="form.iban"
                        @input="validateIban"
                      />
                      <p v-if="ibanError" style="color: red;">
                        {{ ibanError }}
                      </p>
                    </div>
                    <div>
                      <label>IBAN Sahibinin Adı</label>
                      <input
                        type="text"
                        class="uk-input w-full"
                        v-model="form.iban_name"
                      />
                    </div>
                  </template>
                  <template v-if="form.gateway_id == 5">
                    <div>
                      <label>Cüzdan Adresi</label>
                      <input
                        type="text"
                        class="uk-input w-full"
                        v-model="form.iban"
                      />
                    </div>
                    <div>
                      <label>Cüzdan Türü</label>
                      <input
                        type="text"
                        class="uk-input w-full"
                        v-model="form.iban_name"
                      />
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div v-if="form.gateway_id == 1">
                    <label>Banka Bilgileri</label>
                    <textarea
                      class="  border rounded-lg w-full"
                      style="height: 200px;"
                      v-model="form.delivery_iban"
                    ></textarea>
                  </div>
                  <div v-if="form.gateway_id == 5">
                    <label>Cüzdan Bilgileri</label>
                    <textarea
                      class="  border rounded-lg w-full"
                      style="height: 200px;"
                      v-model="form.delivery_iban"
                    ></textarea>
                  </div>
                </template>
                <div>
                  <label>Açıklama</label>
                  <input
                    type="text"
                    class="uk-input w-full"
                    v-model="form.comment"
                  />
                </div>

                <div>
                  <label>Üçünçü sahış aracılığı</label>
                  <select v-model="remitterUsage" class="  uk-select">
                    <option value="0"
                      >Yok (Kendi Gönderecek, Kendi Çekecek)</option
                    >
                    <option value="1"
                      >Var (Başkası Gönderecek, Başkası Çekecek)</option
                    >
                  </select>
                </div>
                <div v-if="remitterUsage == 1">
                  <label>Üçünçü sahış</label>

                  <select v-model="form.lead_remitter_id" class="  uk-select">
                    <option
                      v-for="remt in remitters"
                      :key="remt.id"
                      :value="remt.id"
                    >
                      {{ remt.name }} - {{ remt.city }}  
                    </option>
                  </select>
                </div>
                <div>
                  <label>Eski tarihli işlem mi ? </label>
                  <select v-model="oldTransaction" class="  uk-select">
                    <option value="false">Hayır</option>
                    <option value="true">Evet</option>
                  </select>
                  <div v-if="oldTransaction == 'true'">
                    <label>Tarih seçiniz</label>
                    <datepicker
                      :input="{ name: 'datepicker' }"
                      :form="{ type: 1 }"
                      @changed="(re) => setOldDate(re)"
                    />
                  </div>
                </div>

                <savebutton action="saveDeposit" title="Oluştur"></savebutton>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="loading == false">
          <div class="flex items-center justify-center flex-col ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="140"
              height="140"
              class="text-tile-400"
              viewBox="0 0 32 32"
            >
              <circle cx="19" cy="27" r="1" fill="currentColor" />
              <path
                fill="currentColor"
                d="M29 31H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4zm13-4H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4z"
              />
              <path
                fill="currentColor"
                d="M12 27.3C7.347 25.648 4 21.213 4 16C4 9.383 9.383 4 16 4c4.831 0 8.994 2.876 10.895 7h2.166C27.042 5.746 21.957 2 16 2C8.28 2 2 8.28 2 16c0 6.33 4.225 11.685 10 13.41z"
              />
            </svg>

            <span class="text-lg font-semibold text-black"
              >Tanımlı platform bulunamadı</span
            >
            <span class="text-sm font-light text-gray-400"
              >Müşteriye tanımlı platform olmadığı için para yatırma ve çekme
              işlemi yapılamaz</span
            >
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="flex items-center justify-center flex-col ">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="140"
          height="140"
          class="text-tile-400"
          viewBox="0 0 32 32"
        >
          <circle cx="19" cy="27" r="1" fill="currentColor" />
          <path
            fill="currentColor"
            d="M29 31H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4zm13-4H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4z"
          />
          <path
            fill="currentColor"
            d="M12 27.3C7.347 25.648 4 21.213 4 16C4 9.383 9.383 4 16 4c4.831 0 8.994 2.876 10.895 7h2.166C27.042 5.746 21.957 2 16 2C8.28 2 2 8.28 2 16c0 6.33 4.225 11.685 10 13.41z"
          />
        </svg>

        <span class="text-lg font-semibold text-black"
          >Para işlemi girebilmeniz için müşteriye dönüştürülmüş olmalı ve
          aşağıdaki bilgiler girilmeli</span
        >
        <span class="text-red-600 text-4xl" v-if="lead.is_customer == 0">
          Müşteri dönüştürme işlemi yapılmamış, lütfen önce müşteriye
          dönüştürünüz.
        </span>

        <span class="text-sm font-light text-gray-400">
          Aşağıda girilmiş olan değerleri görebilirsiniz,
          <div class="flex space-x-2">
            <div></div>
            <div>
              <div>MESLEK : {{ $root.getVal(141, lead.occupation_id) }}</div>
              <div>T.C. : {{ lead.tc }}</div>
              <div>ADRES : {{ lead.address }}</div>
              <div>İL : {{ lead.city }}</div>
              <div>İLÇE : {{ lead.ilce }}</div>
            </div>
          </div>
        </span>
      </div>
    </div>

    <div class="w-full" style="overflow-x: scroll; ">
      <div  class="p-2 mb-2">
        <button
          @click="syncTransactionAgents"
          class="global-button cursor-pointer"
          :disabled="syncing"
        >
          <span v-if="!syncing">Eksik işlem sync</span>
          <span v-else>Senkronize ediliyor...</span>
        </button>
      </div>
      <table
        v-if="loading == false && deposits.results"
        class="uk-table uk-table-hover deposit-table uk-table-middle uk-table-divider w-full"
        style="max-width:1200px;"
      >
        <tr>
          <th>İşlem No</th>
          <th>Not</th>
          <th class="">Oluşturan</th>
          <th class="">Temsilci</th>
          <th class="">Retention</th>
          <th class="">İşlem Türü</th>
          <th class="">İşlem Yöntemi</th>
          <th>Talep Edilen Miktar</th>
          <th>Platforma İşlenen Miktar</th>
          <th>Oluşturulma Tarihi</th>
          <th>Finans Onay / Red Tarihi</th>
          <th>Risk Onay / Red Tarihi</th>
          <th>Onay Durumu</th>
          <th>IBAN</th>
          <th>Aşama</th> 
        </tr>
        <tr :key="trx.id" v-for="trx in deposits.results">
          <td class="w-20">
            <div class="flex items-center space-x-2     px-1">
              <span> {{ trx.id }}</span>

              <span @click="edit(trx.id)" class="cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4 text-tile"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M10 7h7q.425 0 .713.288T18 8q0 .425-.288.713T17 9h-7q-.425 0-.712-.288T9 8q0-.425.288-.712T10 7m0 3h7q.425 0 .713.288T18 11q0 .425-.288.713T17 12h-7q-.425 0-.712-.288T9 11q0-.425.288-.712T10 10m2 10H5zm-6 2q-1.25 0-2.125-.875T3 19v-2q0-.425.288-.712T4 16h2V4q0-.825.588-1.412T8 2h11q.825 0 1.413.588T21 4v6q0 .425-.288.713T20 11q-.425 0-.712-.288T19 10V4H8v12h3q.425 0 .713.288T12 17q0 .425-.288.713T11 18H5v1q0 .425.288.713T6 20h5q.425 0 .713.288T12 21q0 .425-.288.713T11 22zm8-1v-1.65q0-.2.075-.387t.225-.338l5.225-5.2q.225-.225.5-.325t.55-.1q.3 0 .575.113t.5.337l.925.925q.2.225.313.5t.112.55q0 .275-.1.563t-.325.512l-5.2 5.2q-.15.15-.337.225T16.65 22H15q-.425 0-.712-.287T14 21m7.5-5.575l-.925-.925zm-6 5.075h.95l3.025-3.05l-.45-.475l-.475-.45l-3.05 3.025zm3.525-3.525l-.475-.45l.925.925z"
                  />
                </svg>
              </span>
            </div>
          </td>
          <td class="w-20">{{  trx.comment }}</td>
          <td class="w-20">{{ $root.getVal(15, trx.insert_user_id) }}</td>
          <td class="w-20">{{ $root.getVal(15, trx.agent_id) }}</td>
          <td class="w-20">{{ $root.getVal(15, trx.retention_id) }}</td>
          <td class="w-20">{{ trx.type }}</td>
          <td class="w-20">{{ $root.getVal(199, trx.gateway_id) }}</td>
          <td class="w-20">
            {{ trx.amount }} {{ $root.getVal(148, trx.currency_id) }}
          </td>
          <td class="w-20">
            {{ trx.amount_platform }}
            {{ $root.getVal(148, trx.platform_currency_id) }}
          </td>
          <td class="w-40">
            <small>{{ trx.created_at }}</small>
          </td>
          <td class="w-40">
            <small>{{ trx.finance_approve_date }}</small>
          </td>
          <td class="w-40">
            <small>{{ trx.risk_approve_date }}</small>
          </td>
          <td class="w-40">
            <small v-if="trx.risk_approve_status == 1">Risk Onayladı </small>
            <small v-if="trx.finance_approve_status == 1"
              >Finans Onayladı</small
            >
          </td>
          <td class="w-40">
            <div>
              <small>{{ trx.iban }}</small>
              <small>{{ trx.iban_name }}</small>
            </div>
            <div>
              <small>{{ trx.delivery_iban }}</small>
            </div>
          </td>
          <td class="w-40">
            <small>{{ $root.getVal(146, trx.status_id) }}</small>
            <ChangeStatus :trx="trx" />
          </td>
        </tr>
      </table>

      <div v-else class="center">
        <vk-spinner ratio="2"></vk-spinner>
      </div>
    </div>

    <vk-modal :stuck="true" class="editFormModal" :show.sync="modalEditShow">
      <EditModal
        :table="modalEdit.table"
        v-if="modalEditShow"
        :id="modalEdit.id"
      />
    </vk-modal>
  </div>
</template>
<script type="text/javascript">
import http from "../../../services/http";

import datepicker from "../../Ui/Search/datetime.vue";

import EventBus from "../EventBus";
import ChangeStatus from "../../TransactionModals/Forms/ChangeStatus.vue";
import EditModal from "../../../views/EditModal.vue";
export default {
  props: ["id", "lead"],
  data() {
    return {
      loading: true,
      oldTransaction: false,
      deposits: [],
      modalEdit: [],
      ibanError: "",
      editId: null,
      modalEditShow: false,
      platforms: [],
      remitters: [],
      remitterUsage: 0,
      syncing: false,
      form: {
        type: null,
        customer_id: this.id,
        amount: 0,
        iban: null,
        iban_name: null,
        currency_id: 1,
        status_id: 1,
      },
    };
  },
  components: {
    ChangeStatus,
    datepicker,
    EditModal,
  },
  computed: {
  allowTransaction() {
    const hasOccupation = this.lead.occupation_id || this.lead.occupation;    
    if (
      this.lead.address &&
      this.lead.city &&
      this.lead.ilce &&
      hasOccupation &&
      this.lead.tc &&
      this.lead.is_customer == 1
    ) {
      return true;
    }
    return false;
  },
  },
  mounted() {
    EventBus.$on("reflesh", () => {
      this.modalEditShow = false;
      this.getData("reflesh");
    });

    EventBus.$on("transactionReload", () => {
      this.getData();
    });

    EventBus.$on("modalClose", () => {
      this.modalEditShow = false;
      this.editId = null;
      console.log("çalıştı");
    });
    EventBus.$on("editModalShow", (data) => {
      if (
        this.$root.cache.me.department == "admin" ||
        this.$root.cache.me.department == "sales_manager"
      ) {
        this.modalEdit.table = data.table;
        this.modalEdit.id = data.id;
        this.modalEditShow = true;
      }
    });
    this.getData();
  },
  methods: {
    setOldDate(dat) {
      this.form.created_at = dat.value;
      console.log(dat, "date");
    },
    edit(id) {
      EventBus.$emit("editModalShow", {
        table: "transactions",
        id,
      });
    },
    formTypeSet(type, status_id) {
      this.form.type = type;
      this.form.status_id = status_id;
    },
    getPlatforms(id) {
      http
        .getPlatformData({
          table: "lead_platforms",
          filters: [
            {
              name: "customer_id",
              value: id,
              type: 1,
            },
          ],
        })
        .then((e) => {
          this.platforms = e.data.results;
        });
    },
    validateIban() {
      const isValidIban = this.isValidIban(this.form.iban);
      if (!isValidIban) {
        this.ibanError = "Geçersiz IBAN numarası";
      } else {
        this.ibanError = "";
      }
    },
    isValidIban(iban) {
      const turkeyIbanRegex = /^TR\d{2}\d{5}[0-9A-Z]{1}[0-9]{16}$/;

      if (iban.length !== 26 || !turkeyIbanRegex.test(iban)) {
        return false;
      }
      return true;
    },
    getData() {
      this.loading = true;
      http
        .getDataLeadDetail({
          table: "transactions",
          limit: 500,
          filters: [
            {
              name: "customer_id",
              value: this.id,
              type: 1,
            },
          ],
        })
        .then((e) => {
          this.deposits = e.data;
          this.loading = false;
          this.getPlatforms(this.id);
          this.getRemitters();
        });
    },
    getRemitters() {
      http
        .getData({
          table: "lead_remitters",
          filters: [
            {
              name: "lead_id",
              value: this.id,
              type: 1,
            },
          ],
        })
        .then((response) => {
          this.remitters = response.data.results;
        });
    },
    saveForm() {
      if (this.form.amount) {
        this.$parent.$emit("loading", true);
        EventBus.$emit("loadingStatus", {
          action: "saveDeposit",
          loading: true,
        });

        http
          .inlineSave({
            table: "transactions",
            type: "insert",
            inputs: this.form,
          })
          .then((resp) => {
            this.form = {
              type: null,
              customer_id: this.id,
              amount: 0,
              iban: null,
              iban_name: null,
              currency_id: 1,
              status_id: 1,
            };
            if (resp.data.success == false) {
              this.$root.errorMessage(resp.data.message);
            } else {
              this.getData();
            }
            EventBus.$emit("loadingStatus", {
              action: "saveDeposit",
              loading: false,
              success: true,
            });
          })
          .catch((resp) => {
            this.$root.errorMessage(
              "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
            );
          });
      }
    },
    syncTransactionAgents() {
      if (confirm("Bu işlem, tüm işlemlerdeki agent, retention ve retention MD bilgilerini lead bilgileriyle güncelleyecektir. Devam etmek istiyor musunuz?")) {
        this.syncing = true;
        http.transaction
          .syncAgents(this.id)
          .then((resp) => {
            if (resp.data.success) {
              EventBus.$emit("bottomMessage", {
                open: true,
                type: "success",
                title: "Başarılı",
                duration: 2000,
                body: resp.data.message,
              });
              this.getData();
            } else {
              this.$root.errorMessage(resp.data.message);
            }
          })
          .catch((error) => {
            this.$root.errorMessage("Senkronizasyon başarısız oldu");
          })
          .finally(() => {
            this.syncing = false;
          });
      }
    },
  },
};
</script>
